import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import HeadMetaTagLegacy from '@/components/metatags/HeadMetaTagLegacy';
import { fetchWebAPINavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import HoneyMoon from '@/features/viagens/HoneyMoon/HoneyMoon';
import HoneyMoonProvider from '@/features/viagens/HoneyMoon/context/HoneyMoonProvider';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';
import fetchMessages from '@/fetchMessages';

export const getServerSideProps: GetServerSideProps = async ({ req, query, ...rest }) => {
  const { messages, locale } = await fetchMessages(rest.locale as string);

  const { filter } = query || {};

  const queryParams = new URLSearchParams();

  if (typeof filter === 'string') {
    queryParams.set('filter', sanitizeQueryParams(filter));
  }

  const qs = locale ? `?locale=${locale}` : '';

  const path = `/viagens/lua-de-mel${qs}`;
  const [navigation, pageProps] = await Promise.all([
    fetchWebAPINavigation({ locale }),
    fetchWebAPIServerDataHandler(path, 'VIAGENS LUA-DE-MEL', req),
  ]);

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined)
    return {
      props: {
        ...props,
        filter: filter || null,
        navigation,
        messages,
      },
    };

  return {
    props: {
      data: null,
    },
  };
};

const Page = ({ data, error, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data.page;
  return (
    <AppProvider navigation={props.navigation}>
      <HeadMetaTagLegacy meta={meta} />
      <HoneyMoonProvider data={data}>
        <HoneyMoon />
      </HoneyMoonProvider>
    </AppProvider>
  );
};

export default Page;
